var clamp=function clamp(min,max,v){if(v>max)return max;if(v<min)return min;return v;};export{clamp};